import { styled } from "styled-components";

export const ProductPriceInfo = styled.div`
  max-width: 100%;
  max-height: 100%;
  text-align: right;
  margin-right: 5px;
`;
